module.exports = __webpack_public_path__ + "img/icbc.fca139cd.png";